const ROUTES = {
  ROOT: "/",
  ABOUT: "/about",
  CARDS: "/cards",
  SINGUP: "/singup",

  FAV_CARDS: "/fav-cards",
  GUEST_FAVORITES: "/guest-favorites",
  CARD_DETATLS: "/product",
  SANDBOX: "/sandbox",
  LOGIN: "/login",
  CREATE_CARD: "/create-card",
  EDIT_CARD: "/edit-card",
  EDIT_ACCOUNT: "/edit-account",
  CATEGORY_CARDS: "/category",
  CART: "/cart",
  CHECKOUT: "/checkout",
  ADMIN_COUPONS: "/admin/coupons",
  ADMIN_ORDERS: "/admin/orders",
  ADMIN_SENT_ORDERS: "/admin/sent-orders",
  ADMIN_ANALYTICS: "/admin/analytics",
  ADMIN_MARKETING: "/admin/marketing",
  ADMIN_CUSTOMERS: "/admin/customers",
  ADMIN_CATEGORIES: "/admin/categories",
  ADMIN_PRODUCT_OPTIONS: "/admin/product-options",
  ADMIN_ALL_PRODUCTS: "/admin/all-products",
  CONTACT: "/contact",
  ACCESSIBILITY: "/accessibility",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS: "/terms",
  FAQ: "/faq",
  CANCEL_TRANSACTION: "/cancel-transaction",
  MATH: "/math",
  PAYMENT: "/payment",
  PAYMENT_CALLBACK: "/payment-callback",
};
export const SANDBOX_ROUTES_FATHER = {
  COMPONENT: "component",
  EVENTS: "events",
  INTRODUCTION: "introduction",
  MUI_SANDBOX: "mui_sandbox",
  NAVIGATION: "navigation",
  PROPS: "props",
  USE_STATE: "use_state",
  LIFESYCLE: "lifesecily-hooks",
  CUSTOM: "custom",
  MEMOIZAITON: "memoizition",
  CONTEXT: "context",
  FORM_TEST: "form",
};
export const SANDBOX_ROUTES_SONS = {
  COMPONENT: {
    A: "a",
    B: "b",
  },
  EVENTS: {
    A: "a",
    B: "b",
  },
  INTRODUCTION: {
    A: "a",
    B: "b",
  },
  MUI_SANDBOX: {
    A: "a",
    B: "b",
  },
  NAVIGATION: {
    A: "a",
    B: "b",
  },
  PROPS: {
    A: "a",
    B: "b",
  },
  USE_STATE: {
    A: "a",
    B: "b",
  },
  LIFESYCLE: {
    A: "a",
    B: "b",
  },
  CUSTOM: {
    A: "a",
    B: "b",
  },
  MEMOIZAITON: {
    A: "a",
    B: "b",
  },
  CONTEXT: {
    A: "a",
    B: "b",
  },
  FORM_TEST: {
    A: "a",
    B: "b",
  },
};

export default ROUTES;
